import classNames from "classnames";
import React from "react";
import { Link } from "react-router";
import { LinkButton } from "../../../../core/atoms/atoms";
import * as WebRoutes from "@travellocal/utils/webRoutes";

import "./howItWorksSection.scss";

interface ILink {
  text: string;
  url?: string;
}

interface Props {
  heading?: ILink;
  cta?: ILink;
  className?: string;
  links?: boolean;
  columnClasses?: string;
}

export const HowItWorksSection = ({ heading, cta, className, links = true, columnClasses = "is-full is-3-desktop" }: Props) => {
  return (
    <div className={classNames("how-it-works-section", className)}>
      <div className="how-it-works-header columns is-centered is-marginless is-paddingless">
        <header className="column is-10-tablet is-6-desktop">
          {heading && (
            <h2 className="heading--2">
              {heading.url ?
                <Link to={heading.url}>{heading.text}</Link> : heading.text
              }
            </h2>
          )}
        </header>
      </div>

      <ul className="how-it-works-ul width-wrapper columns is-centered is-multiline">
        <li className={`how-it-works-list-item column ${columnClasses}`}>
          <div className="step">
            <span className="step-count">1.</span>
            <div className="step-text">
              <h3>Browse</h3>
              <p className="text--dark">
                Our website is full of inspiration to help you choose where to go.
              </p>
            </div>
          </div>
          {links && <Link to={WebRoutes.aboutHowItWorks()} />}
        </li>
        <li className={`how-it-works-list-item column ${columnClasses}`}>
          <div className="step">
            <span className="step-count">2.</span>
            <div className="step-text">
              <h3>Plan</h3>
              <p className="text--dark">
              We connect you with a trusted local agent in your destination to create the perfect trip for you.
              </p>
            </div>
          </div>
          {links && <Link to={WebRoutes.aboutHowItWorks()} />}
        </li>
        <li className={`how-it-works-list-item column ${columnClasses}`}>
          <div className="step">
            <span className="step-count">3.</span>
            <div className="step-text">
              <h3>Book</h3>
              <p className="text--dark">
                You can book with confidence because your TravelLocal holiday is 100% financially protected.
              </p>
            </div>
          </div>
          {links && <Link to={WebRoutes.aboutHowItWorks()} />}
        </li>
        <li className={`how-it-works-list-item column ${columnClasses}`}>
          <div className="step">
            <span className="step-count">4.</span>
            <div className="step-text">
              <h3>Travel</h3>
              <p className="text--dark">
                Enjoy your tailor-made trip with the reassurance of 24/7 support should you need it.
              </p>
            </div>
          </div>
          {links && <Link to={WebRoutes.aboutHowItWorks()} />}
        </li>
      </ul>

      {cta && (
        <LinkButton
          buttonClass="secondary-button"
          className="heading--4 text--dark"
          to={cta.url}
        >
          {cta.text}
        </LinkButton>
      )}
    </div>
  );
};
